import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSleep: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sleep, snooze, zzz"} maskId="square-filled-radius-0-stroke-1-IconSleep"><path fillRule="evenodd" clipRule="evenodd" d="M11 2H16.5V3.45711L12 7.95711V8H16.5V9H11V7.54289L15.5 3.04289V3H11V2ZM3 8H9V9.18103L4.15085 15H9V16H3V14.819L7.84915 9H3V8ZM12 12H20V13.3359L13.0455 21H20V22H12V20.6641L18.9545 13H12V12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSleep;
